


let tripDetailsSetup = () => {

    let startInput = $('#input_start_date');
    let endInput = $('#input_end_date');
    let periodInput = $('#hid_period');

    let now = moment();
    var min = now.add(1, 'day');
    var max = min.clone().add(3, 'month');

    startInput.datepicker({
        leftArrow: '<i class="fa fa-long-arrow-left"></i>',
        rightArrow: '<i class="fa fa-long-arrow-right"></i>',
        startDate: min.toDate(),
        date: min.toDate(),
        endDate: max.toDate(),
        format: 'dd/mm/yyyy',
        language: 'ro'
    });

    endInput.datepicker({
        leftArrow: '<i class="fa fa-long-arrow-left"></i>',
        rightArrow: '<i class="fa fa-long-arrow-right"></i>',
        startDate: min.toDate(),
        date: min.toDate(),
        format: 'dd/mm/yyyy',
        language: 'ro'
    });

    // $('[data-period]').bind('click', function (e) {
    //     $('#hid_period').val(($(e.target).attr('data-period')));
    //     $('[data-period]').removeClass('selected');
    //     $(e.target).addClass('selected');

    //     if(startInput.val())
    //         endInput.val(
    //             moment(startInput.val(), 'DD/MM/YYYY')
    //             .add(periodInput.val(), 'days')
    //             .format('DD/MM/YYYY')
    //         );
    // });

    $('[data-amount-insured-id]').bind('click', function (e) {
        $('#hid_amount_insured_id').val(($(e.target).attr('data-amount-insured-id')));
        $('[data-amount-insured-id]').removeClass('selected');
        $(e.target).addClass('selected');
    })

    // startInput.on('changeDate', (e) => {
        // endInput.val(moment(e.date, 'DD/MM/YYYY').add(periodInput.val(), 'days').format('DD/MM/YYYY'));

        // let minDate = new Date(moment(e.date, 'DD/MM/YYYY').add(1,'days').valueOf());
        // endInput.datepicker('setStartDate', minDate);

        // updatePeriod();
    // })
    endInput.on('changeDate', (e) => {
        // $('[data-period]').removeClass('selected');
        updatePeriod();
    })

    // startInput.change( () => {
    //     endInput.val(moment(startInput.val(), 'DD/MM/YYYY').add(periodInput.val(), 'days').format('DD/MM/YYYY'));

    //     let minDate = new Date(moment(startInput.val(), 'DD/MM/YYYY').add(1,'days').valueOf());
    //     endInput.datepicker('setStartDate', minDate);

    //     updatePeriod();
    // })

    endInput.change( () => {
        // $('[data-period]').removeClass('selected');
        updatePeriod();
    })

    var updatePeriod = () => {
        let a = moment(startInput.val(), 'DD/MM/YYYY');
        let b = moment(endInput.val(), 'DD/MM/YYYY');
        let period = b.diff(a, 'days')

        $('#hid_period').val(period);
        // $("[data-period='" + period + "']").addClass('selected');
    }

    $('#date-error').addClass('d-none');
}

window.tripDetailsSubmit = (formId) => {
    event.preventDefault();

    let form = $(`#${formId}`);
    if(!form[0].reportValidity()) return;
    if ($('#input_start_date').val() === $('#input_end_date').val()) {
        $('#date-error').removeClass('d-none');
        $('#date-error').addClass('d-block');
        return;
    }
    // Display modal
    document.getElementById('id01').style.display = 'block';
    $(window).scrollTop(0);
    $('html').css({overflow: 'hidden'});

    // Change onclick for modal's primary button
    $('#btnSubmitId01Modal').on('click', function() {
        localStorage.setItem('vuex', '');
        form.submit();
    });
}

$(document).ready(function () {
    tripDetailsSetup();
});